"use client";

import { useState } from "react";

export default function CopyEmailBanner({ email }: { email: string }) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API unavailable (e.g. insecure context) -- the email is
      // already visible as plain text, so this is a no-op fallback.
    }
  }

  return (
    <div className="mx-auto mt-6 flex w-fit items-center gap-3 rounded-full border border-slate-200 bg-white/80 py-2 pl-5 pr-2 shadow-sm backdrop-blur-sm dark:border-slate-800 dark:bg-[#0f172a]/80">
      <span className="text-sm font-semibold text-slate-900 dark:text-white">{email}</span>
      <button
        type="button"
        onClick={handleCopy}
        className="rounded-full bg-slate-900 px-4 py-1.5 text-xs font-semibold text-white transition hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200"
      >
        {copied ? "Copied!" : "Copy"}
      </button>
    </div>
  );
}
